<template>
  <div id="app">
    <vue-dropzone
      id="drop1"
      ref="dropzone"
      :options="dropOptions"
      @vdropzone-complete="afterComplete"
      @vdropzone-file-added="onFileAdded"
      @vdropzone-sending="sendingEvent"
    />
    <button @click="removeAllFiles">Remove All Files</button>
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone'

export default {
  components: {
    vueDropzone
  },
  data: () => ({
    dropOptions: {
      url: 'https://omiu70flhb.execute-api.us-east-1.amazonaws.com/dev/upload',
      // maxFilesize: 2, // MB
      // maxFiles: 4,
      // chunking: true,
      // chunkSize: 500, // Bytes
      thumbnailWidth: 150, // px
      thumbnailHeight: 150,
      addRemoveLinks: true,
      uploadMultiple: false
    }
  }),
  methods: {
    afterComplete (file) {
      console.log(file)
    },
    removeAllFiles () {
      this.$refs.dropzone.removeAllFiles()
    },
    onFileAdded (file) {
      console.log(file)
    },
    sendingEvent (file, xhr, formData) {
      const toBase64 = file =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = error => reject(error)
        })
      console.log('Base64:')
      console.log(toBase64(file))

      //  toBase64(file).then(values => {
      //     console.log(values);
      //     let fileBase64 = values.split(",").pop();
      //     console.log(fileBase64);

      //   });
      // wait(3000).then(() => console.log('Hello!'));

      // let test = toBase64(file).then(function(result) {
      //   console.log('MOn')
      //   console.log(result)
      //   return result
      //   });
      console.log('Testing:::::')
      console.log(toBase64(file).then(result => { console.log('test>>>> ' + result); return result }))

      console.log(Promise.resolve)

      let valueB64 = toBase64(file).then(function (result) { return result })
      // console.log(valueB64)
      let filename = file.upload.filename
      // console.log("---- BASE 64 file ----");
      // console.log(encodedfile);
      formData.append('encoded_data', encodedfile)
      formData.append('filename', filename)
    }
  }
}
</script>
